import React from "react";
import RealizationOrdersPage from "./RealizationOrdersPage";
import useRealizationOrders from "./useRealizationOrders";
import RealizationOrdersWrapper from "./RealizationOrdersWrapper";

function RealizationOrders() {
  return <RealizationOrdersWrapper {...useRealizationOrders()} />;
}

export default RealizationOrders;
